import React from 'react';

const ContactInfo = () => {
  const infoItems = [
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z" />
        </svg>
      ),
      label: 'Telefon',
      value: '+4790291892',
      sub: 'Man–Fre 08:00–17:00',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      ),
      label: 'E-post',
      value: 'kontakt@vei-assistent.com',
      sub: 'Svar innen 1–2 virkedager',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      label: 'Adresse',
      value: 'Storgata 1, 0155 Oslo',
      sub: 'Norge',
    },
  ];

  return (
    <div style={{ position: 'relative' }}>
      {/* Background panel offset */}
      <div style={{
        position: 'absolute',
        top: '12px', left: '12px',
        right: '-12px', bottom: '-12px',
        background: 'rgba(0,79,152,0.06)',
        border: '1px solid rgba(0,79,152,0.1)',
        borderRadius: '2px',
        pointerEvents: 'none',
      }} />

      <div style={{
        position: 'relative',
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(224,228,232,0.1)',
        borderTop: '3px solid #FF5722',
        borderRadius: '2px',
        padding: '32px',
      }}>
        {/* Header */}
        <div style={{ marginBottom: '32px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
            <div style={{ width: '28px', height: '2px', background: '#FF5722' }} />
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#FF5722' }}>Kontaktinfo</span>
          </div>
          <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '20px', fontWeight: 600, color: 'var(--color-foreground)', letterSpacing: '0.01em' }}>
            Kom i kontakt
          </h3>
        </div>

        {/* Info items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {infoItems?.map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
              <div style={{
                width: '42px', height: '42px', flexShrink: 0,
                background: 'rgba(255,87,34,0.08)',
                border: '1px solid rgba(255,87,34,0.2)',
                borderRadius: '2px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {item?.icon}
              </div>
              <div>
                <p style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-muted-foreground)', marginBottom: '4px' }}>
                  {item?.label}
                </p>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 500, color: 'var(--color-foreground)', marginBottom: '2px' }}>
                  {item?.value}
                </p>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'var(--color-muted-foreground)' }}>
                  {item?.sub}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div style={{ height: '1px', background: 'rgba(224,228,232,0.1)', margin: '32px 0' }} />

        {/* Response time block */}
        <div style={{
          padding: '16px',
          background: 'rgba(0,79,152,0.06)',
          border: '1px solid rgba(0,79,152,0.12)',
          borderLeft: '3px solid var(--color-primary)',
          borderRadius: '0 2px 2px 0',
        }}>
          <p style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-primary)', marginBottom: '6px' }}>
            Responstid
          </p>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.6 }}>
            E-post: 1–2 virkedager · Telefon: Umiddelbart i åpningstid · SMS: Innen 4 timer
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
